export const MEETING_ROOM_SEARCH_PATH = '/home/roombooking';
